import { createContext } from "react";
import { createCommentsThreadStore } from "../stores/commentsThreadStore";

export interface CommentsThreadContextType {
	store: ReturnType<typeof createCommentsThreadStore>;
}

const CommentsThreadContext = createContext<CommentsThreadContextType | null>(null);
export default CommentsThreadContext;
